module.exports = __webpack_public_path__ + "img/selected3-min.08c6479c.png";